import { FC } from 'react'

import { Text } from '@revolut-internal/ui-kit'

import { BreachCell } from 'components/TableCells/BreachCell'
import { CountMetric } from 'types'
import { formatNumber } from 'utils/formatNumber'
import { pluralize } from 'utils/pluralize'

type CountCellProps = {
  metric: CountMetric | null
  entityName: string
  isGrouped: boolean
}

export const CountCell: FC<CountCellProps> = ({ metric, entityName, isGrouped }) => {
  if (!metric) {
    return <Text color="grey-tone-20">-</Text>
  }

  const formattedValue = isGrouped
    ? `${formatNumber(metric.value)} ${pluralize(entityName, metric.value, true)}`
    : formatNumber(metric.value)

  return <BreachCell slaBreach={metric.slaBreach}>{formattedValue}</BreachCell>
}
